import React, { useState, useEffect } from 'react';
import { Card, Spinner, Alert, ListGroup } from 'react-bootstrap';
import profissionaisService from '../../api/profissionaisService';
import DateSelector from '../../components/data-selector/index';
import './index.css';
import agendamentosService from '../../api/agendamentosService';

const ProfissionalAgenda = () => {
  const [agendamentoProfissionais, setAgendamentoProfissionais] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);
  const [selectedProfissional, setSelectedProfissional] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProfissionais = async () => {
      setLoading(true);
      setError(null);
      try {
        setAgendamentoProfissionais([]);
        const response = await agendamentosService.listar(selectedDate);
        if(!!response){
          const uniqueProfissionais = response.reduce((acc, curr) => {
            if (!acc.some(prof => prof.profissionalId === curr.profissionalId)) {
              acc.push(curr);
            }
            return acc;
          }, []);
          setAgendamentoProfissionais(uniqueProfissionais);
        }
      } catch (err) {
        setError('Erro ao buscar profissionais.');
      } finally {
        setLoading(false);
      }
    };
    fetchProfissionais();
  }, [selectedDate]);

  const handleProfissionalClick = async (profissionalId) => {
    setLoading(true);
    setError(null);
    setSelectedProfissional(profissionalId);

    try {
      const dataFormatada = selectedDate.toISOString().split('T')[0];
      const response = await agendamentosService.listarPorProfissionaleData(dataFormatada, profissionalId);
      setAgendamentos(response);
    } catch (err) {
      setError('Erro ao buscar pacientes.');
    } finally {
      setLoading(false);
    }
  };

  const handleNextDay = () => {
    const nextDay = new Date(selectedDate);
    nextDay.setDate(selectedDate.getDate() + 1);
  
    if (nextDay.getDay() === 0) { 
      nextDay.setDate(nextDay.getDate() + 1);
    }
  
    setSelectedDate(nextDay);
    setSelectedProfissional(null)
  };
  
  const handlePrevDay = () => {
    const prevDay = new Date(selectedDate);
    prevDay.setDate(selectedDate.getDate() - 1);
  
    if (prevDay.getDay() === 0) { 
      prevDay.setDate(prevDay.getDate() - 1);
    }
  
    setSelectedDate(prevDay);
    setSelectedProfissional(null)
  }; 

  return (
    <div className="profissional-agenda-container">
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Agenda dos Profissionais</Card.Title>
          <hr />

          <DateSelector 
            selectedDate={selectedDate}
            onDateChange={(date) => setSelectedDate(date)}
            onNextDay={handleNextDay}  
            onPrevDay={handlePrevDay}
          />

          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Carregando...</span>
              </Spinner>
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            <div className="d-flex flex-row">
              {agendamentoProfissionais && agendamentoProfissionais.length > 0 ? (
                <>
                  <ListGroup as="ul" className="me-4">
                    <h5>Profissionais</h5>
                    {agendamentoProfissionais.map((agendamento) => (
                      <ListGroup.Item
                        key={agendamento.profissionalId}
                        action
                        onClick={() => handleProfissionalClick(agendamento.profissionalId)}
                        active={selectedProfissional === agendamento.profissionalId}
                      >
                        {agendamento.profissional?.nome}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>

                  <ListGroup as="ul">
                    <h5>Pacientes</h5>
                    {selectedProfissional ? (
                      agendamentos.length > 0 ? (
                        agendamentos.map((agendamento) => (
                          <ListGroup.Item key={agendamento.id}>
                            {agendamento.horario?.horario} - {agendamento?.paciente ? <b>{agendamento?.paciente.nome}</b> : <i>Sem paciente agendado</i>}
                          </ListGroup.Item>
                        ))
                      ) : (
                        <p className="text-center">Nenhum paciente para esta data.</p>
                      )
                    ) : (
                      <p className="text-center">Selecione um profissional para visualizar os pacientes.</p>
                    )}
                  </ListGroup>
                </>
              ) : (
                <p className="text-end">Nenhum profissional disponível nesta data.</p>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ProfissionalAgenda;
